import { useIsClient } from '../../scripts/hooks/useIsClient';
import { AdhesionPlacement } from './adhesionPlacement';
import { Zone } from './zone';

export function usesAditudeMobileMappings(userAgent: string) {
  const isTablet =
    /(tablet|ipad|playbook|silk)/i.test(userAgent) || (userAgent.includes('Android') && !userAgent.includes('Mobile'));

  return (
    !isTablet &&
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|rgbmedia-app|ios-app|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/i.test(
      userAgent
    )
  );
}

export const AditudeAdhesionPlacement = () => {
  const isClient = useIsClient();
  if (!isClient) {
    return null;
  }

  const usesMobileMappings = usesAditudeMobileMappings(window.navigator.userAgent || '');

  return (
    <AdhesionPlacement height={usesMobileMappings ? 100 : 90} maxWidth={usesMobileMappings ? 320 : 970}>
      <Zone type={usesMobileMappings ? 'mobile_footer' : 'bottom_rail'} destroyOnUnmount={true} />
    </AdhesionPlacement>
  );
};
